const getters = {
  category: state => state.user.category || 'A0',
  email: state => state.user.email || '',
  phone: state => state.user.phone || '',
  userId: state => state.user.userId || '',
  username: state => state.user.username || '',
  nickName: state => state.user.nickName || '',
  userType: state => state.user.userType || '',
  enterpriseName: state => state.user.enterpriseName || '',
  legalPerson: state => state.user.legalPerson || '',
  name: state => state.user.name || '',
}

export default getters
